<div *ngIf="flightConfigurationDto != undefined" class="setting-list-wrap">
    <div *ngIf="droneSpecification?.seq != droneCode.CUSTOM_DRONE" class="setting-info-list">
        <ul>
            <li>
                <div class="subject-box">
                    <span class="subject">
                        {{ "flightConfiguration.droneWindResistance" | translate }}
                    </span>
                    <span class="unit">
                        <span *ngIf="droneSpecification != undefined" class="data-txt">
                            {{ userUnit.convertCalculatedWindSpeed(droneSpecification.windResistance) }}
                        </span>
                        {{ userUnit.convertWindSpeedUnitText() }}
                    </span>
                </div>
            </li>
            <li>
                <div class="subject-box">
                    <span class="subject">
                        {{ "flightConfiguration.droneMinimumTemperature" | translate }}
                    </span>
                    <span class="unit">
                        <span *ngIf="droneSpecification != undefined" class="data-txt">
                            {{ userUnit.convertCalculatedTemperature(droneSpecification.minimumTemperature) }}
                        </span>
                        {{ userUnit.convertTemperatureUnitText() }}
                    </span>
                </div>
            </li>
            <li>
                <div class="subject-box">
                    <span class="subject">
                        {{ "flightConfiguration.droneMaximumTemperature" | translate }}
                    </span>
                    <span class="unit">
                        <span *ngIf="droneSpecification != undefined" class="data-txt">
                            {{ userUnit.convertCalculatedTemperature(droneSpecification.maximumTemperature) }}
                        </span> 
                        {{ userUnit.convertTemperatureUnitText() }}
                    </span>
                </div>
            </li>
            <li>
                <div class="subject-box">
                    <span class="subject">
                        {{ "flightConfiguration.droneHumidity" | translate }}
                    </span>
                    <span class="unit">
                        <span *ngIf="droneSpecification != undefined" class="data-txt">
                            {{ droneSpecification.maximumHumidity }}
                        </span> 
                        %
                    </span>
                </div>
            </li>
        </ul>
    </div>

    <ul class="setting-list">
        <li>
            <div class="subject-box">
                <span class="subject">
                    {{ "flightConfiguration.maximumWindSpeed" | translate }}
                </span>
                <span *ngIf="userUnit != undefined" class="unit">
                    {{ userUnit.convertWindSpeedUnitText() }}
                </span>
                <span *ngIf="userUnit == undefined" class="unit">
                    m/s
                </span>
            </div>
            <div class="con-box">
                <input (change)="changeConfiguration()" type="number" [(ngModel)]="calculatedFlightConfigurationDto.windResistance">
            </div>
        </li>
        <li>
            <div class="subject-box">
                <span class="subject">
                    {{ "flightConfiguration.minimumTemperature" | translate }}
                </span>
                <span *ngIf="userUnit != undefined" class="unit">
                    {{ userUnit.convertTemperatureUnitText() }}
                </span>
                <span *ngIf="userUnit == undefined" class="unit">
                    ℃
                </span>
            </div>
            <div class="con-box">
                <input (change)="changeConfiguration()" type="number" [(ngModel)]="calculatedFlightConfigurationDto.minimumTemperature">
            </div>
        </li>
        <li>
            <div class="subject-box">
                <span class="subject">
                    {{ "flightConfiguration.maximumTemperature" | translate }}
                </span>
                <span *ngIf="userUnit != undefined" class="unit">
                    {{ userUnit.convertTemperatureUnitText() }}
                </span>
                <span *ngIf="userUnit == undefined" class="unit">
                    ℃
                </span>
            </div>
            <div class="con-box">
                <input (change)="changeConfiguration()" type="number" [(ngModel)]="calculatedFlightConfigurationDto.maximumTemperature">
            </div>
        </li>
        <li>
            <div class="subject-box">
                <span class="subject">
                    {{ "flightConfiguration.humidity" | translate }}
                </span>
                <span class="unit">
                    %
                </span>
            </div>
            <div class="con-box">
                <input (change)="changeConfiguration()" type="number" [(ngModel)]="calculatedFlightConfigurationDto.maximumHumidity">
            </div>
        </li>
        <li>
            <div class="subject-box">
                <span class="subject">
                    {{ "flightConfiguration.precipitation" | translate }}
                </span>
                <span class="unit">
                    %
                </span>
            </div>
            <div class="con-box">
                <input (change)="changeConfiguration()" type="number" [(ngModel)]="calculatedFlightConfigurationDto.precipitation">
            </div>
        </li>
        <li>
            <div class="subject-box">
                <span class="subject">
                    {{ "flightConfiguration.cloudCover" | translate }}
                </span>
                <span class="unit">
                    %
                </span>
            </div>
            <div class="con-box">
                <input (change)="changeConfiguration()" type="number" [(ngModel)]="calculatedFlightConfigurationDto.cloudCover">
            </div>
        </li>
        <li>
            <div class="subject-box">
                <span class="subject">
                    {{ "flightConfiguration.sight" | translate }}
                </span>
                <span *ngIf="userUnit != undefined" class="unit">
                    {{ userUnit.convertDistanceUnitText() }}
                </span>
                <span *ngIf="userUnit == undefined" class="unit">
                    km
                </span>
            </div>
            <div class="con-box">
                <input (change)="changeConfiguration()" type="number" [(ngModel)]="calculatedFlightConfigurationDto.visibility">
            </div>
        </li>
        <li>
            <div class="subject-box">
                <span class="subject">
                    {{ "flightConfiguration.maximumSatelliteCount" | translate }}
                </span>
            </div>
            <div class="con-box">
                <input (change)="changeConfiguration()" type="number" [(ngModel)]="calculatedFlightConfigurationDto.satelliteCount">
            </div>
        </li>
    </ul>
</div>